import { PALETTE } from './color-palette';

export function getUserColor(userId: string): string {
  const index = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return PALETTE[index % PALETTE.length].value;
}
